import React, { useEffect, useRef } from "react";
import "./HomeAbout.css";

const HomeAbout = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("about-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="home-about" ref={sectionRef}>

      {/* PHOTO SIDE */}
      <div className="about-photo-wrap">
        <div className="about-photo-tape about-tape-tl" />
        <div className="about-photo-tape about-tape-tr" />
        <div className="about-photo-frame">
          <img
            src="/images/2N0A1114.jpg"
            alt="Biz Baz Events"
            className="about-photo"
          />
        </div>
      </div>

      {/* TEXT SIDE */}
      <div className="about-text">
        <h2 className="about-heading">
          What We Are<br />
          <em>Where cultures connect.</em>
        </h2>
       <p className="about-body">
  Biz Baz Events Ltd is a Nairobi-based creative economy platform that
  develops networks and infrastructure to connect Kenya's vendor and maker
  community, including makers, craftpreneurs, and creative entrepreneurs,
  with each other as well as with consumers, buyers, and markets.
</p>
<p className="about-body">
  Our flagship Bizarre Bazaar Festivals, held four times a year in Nairobi,
  are the live expression of our platform and form part of a broader
  offering that includes content, training, partnerships, and trade
  linkages. All these initiatives aim to grow, develop, and connect the
  community at the heart of Kenya's creative economy. We are where Cultures
  Connect.
</p>
<div className="about-rule" />
<p className="about-sign">
  Mission: Expand market access and support sustainable businesses for Kenya's creative entrepreneurs and their peers across Africa by connecting them with consumers, buyers, and markets regionally and internationally.

We achieve this through strategic partnerships, market participation, online tools, and training.
</p>
      </div>

    </section>
  );
};

export default HomeAbout;